import { ShieldCheck, Eye, UserCheck, Cloud, Lock, Terminal } from "lucide-react";

const expertiseCards = [
  {
    icon: ShieldCheck,
    title: "Endpoint Detection & Response (EDR/XDR)",
    description: "EDR and XDR deployment at enterprise scale — from scratch policy creation to fine-tuning detection profiles and custom rules. Reduced endpoint-based attacks by up to 45% across deployments.",
    tags: ["CrowdStrike Falcon", "Palo Alto Cortex XDR", "Trend Micro Vision One"],
  },
  {
    icon: Eye,
    title: "Next-Gen SIEM & Threat Intelligence",
    description: "End-to-end NG-SIEM implementation — ingesting logs from firewalls, cloud APIs, and third-party platforms. Custom CQL correlation rules mapped to MITRE ATT&CK for precision threat detection.",
    tags: ["CrowdStrike NG-SIEM", "Microsoft Sentinel", "MITRE ATT&CK"],
  },
  {
    icon: UserCheck,
    title: "Identity Protection (IDP)",
    description: "Designing and deploying identity security controls including MFA, PAM, and real-time SOC alerting for high-risk identity activity. Reduces credential-based attack surfaces significantly.",
    tags: ["CrowdStrike Falcon IDP", "Microsoft Entra ID", "SC-300"],
  },
  {
    icon: Cloud,
    title: "Cloud Security (CNAPP/CSPM)",
    description: "Securing cloud workloads across AWS, GCP, and Azure. Integrating security into CI/CD pipelines to embed protection throughout the software development lifecycle.",
    tags: ["CrowdStrike CNAPP", "CSPM", "AWS", "Azure", "GCP"],
  },
  {
    icon: Lock,
    title: "Data Loss Prevention & Compliance",
    description: "Designing and deploying DLP policies across M365 services, integrated with SIEM for incident detection. Frameworks aligned to NIST and ISO 27001.",
    tags: ["Microsoft Purview", "Forcepoint DLP", "SC-400", "NIST", "ISO 27001"],
  },
  {
    icon: Terminal,
    title: "Security Automation & Scripting",
    description: "Automating threat intel gathering, endpoint isolation, and incident response workflows — cutting manual SOC effort by up to 50%.",
    tags: ["Python", "PowerShell", "psfalcon", "Fusion Playbooks", "ServiceNow"],
  },
];

export default function Expertise() {
  return (
    <section id="expertise" className="py-20 md:py-32 bg-white" data-testid="expertise-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#06B6D4]">Core Expertise</span>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl font-bold tracking-tight text-[#111827] mt-3">
            What I Specialize In
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {expertiseCards.map((card) => (
            <div
              key={card.title}
              className="bg-white border border-[#E5E7EB] rounded-2xl p-6 md:p-8 card-hover"
              data-testid={`expertise-card-${card.title.slice(0, 15).toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="w-11 h-11 rounded-xl bg-[#06B6D4]/10 flex items-center justify-center mb-5">
                <card.icon className="w-5 h-5 text-[#06B6D4]" />
              </div>
              <h3 className="font-['Outfit'] text-lg font-bold text-[#111827] mb-3">{card.title}</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed mb-4">{card.description}</p>
              <div className="flex flex-wrap gap-1.5">
                {card.tags.map((tag) => (
                  <span
                    key={tag}
                    className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#06B6D4]/10 text-[#06B6D4] border border-[#06B6D4]/20"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
